module.exports = __webpack_public_path__ + "static/media/OCFL-News-Page-Solved-2.b7e355cf.png";